import { IUserToken } from 'interfaces/userToken';
import { hotjar } from 'react-hotjar';
import { BehaviorSubject } from 'rxjs';

export enum enHotjarEvents {
  THREE_REGISTERED_FEATURES = 'three_registered_features'
}

interface IHorjarUser {
  id: number;
  email: string;
  name: string;
  belt: string;
  isClubeBlack: boolean;
}
export class HotjarService {
  private HOTJAR_ID = 3006539;
  private HOTJAR_SNIPPET_VERSION = 6;
  private showSurvey = new BehaviorSubject<boolean>(false);

  public init() {
    hotjar.initialize(this.HOTJAR_ID, this.HOTJAR_SNIPPET_VERSION);
  }

  public setUser(id: number, user: Omit<IUserToken, 'betaFeatures'>) {
    const hotjarUser: IHorjarUser = {
      id: user?.id,
      email: user?.email,
      name: user?.name,
      belt: user?.belt,
      isClubeBlack: user?.isClubeBlack
    };

    hotjar.identify(String(id), hotjarUser);
  }

  public setShowSurvey(showSurvey: boolean) {
    this.showSurvey.next(showSurvey);
  }

  public getShowSurvey() {
    return this.showSurvey.asObservable();
  }

  public submitEvent(event: enHotjarEvents) {
    hotjar.event(event);
  }
}

const HotjarServiceFactory = () => new HotjarService();
const hotjarService = HotjarServiceFactory();

export default hotjarService;
